import authApi from './authApi';

const listingService = {
  createListing: async (data) => {
    const response = await authApi.post('/api/listings', data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  },

  uploadImages: async (listingId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('images', file));
    const response = await authApi.post(`/api/listings/${listingId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getMyListings: async (uid) => {
    const response = await authApi.get('/api/listings', { params: { uid } });
    return response.data;
  },

  updateListing: async (id, data) => {
    const response = await authApi.put(`/api/listings/${id}`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  },

  deleteListing: async (id) => {
    await authApi.delete(`/api/listings/${id}`);
  },
};

export default listingService;
